import React from 'react';
import PropTypes from 'prop-types';

import { CodeSnippet } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const MagazineModuleEmbedCode = ({
    code,
}) => {
    return (
        <div className='relative bg-white'>
            <div className='layout-container'>
                <div className='w-full px-10 sm:px-5 md:px-10 module-embed-code'>
                    <CodeSnippet html={code} />
                </div>
            </div>
        </div>
    );

};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

MagazineModuleEmbedCode.propTypes = {
    code: PropTypes.string,
};

export default MagazineModuleEmbedCode;
